//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InputMoney from '../../../../shared-components/inputs/InputMoney';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';
import Alcada from './Alcada';

export default {
  name: 'AlcadaForm',
  data() {
    return {
      alcada: new Alcada(),
      alcadaResources: this.$api.alcada(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      listaFluxos: [],
      listaEstruturaUsuarios: [],
      layoutClass: { wrap: true },
      dialog: {
        content: '',
      },
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        valorFinalMaiorInicial: () => {
          const valorFinal = this.alcada.vlrLimiteFinal;
          return (valorFinal > this.alcada.vlrLimiteInicial) || this.$t('errors.valor_inicial_mayor_final');
        },
      },
    };
  },
  watch: {
  },
  components: {
    Confirm,
    InputMoney,
  },
  methods: {
    cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CADASTRO_ALCADA_CANCELAR');
    },
    editar(alcada) {
      this.alcada = new Alcada({ ...alcada });
    },
    limparFormulario() {
      this.alcada = new Alcada();
      setTimeout(() => this.$refs.form.reset(), 1E2);
    },
    buscarTiposFluxo() {
      this.alcadaResources.listarTiposFluxo()
        .then((response) => {
          this.listaFluxos = response.data.resposta;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    setarTipoFluxo() {
      this.alcada.idWorkflowTipo = this.alcada.fluxo.id;
      delete this.alcada.fluxo;
    },
    buscarEstruturasDeUsuario() {
      this.estruturaUsuarioResources.selecao({ limit: 10000 })
        .then((resultado) => {
          this.listaEstruturaUsuarios = resultado.data;
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    setarEstruturaUsuario() {
      this.alcada.idEstruturaUsuario = this.alcada.estruturaUsuario.id;
      this.alcada.nomEstruturaUsuario = this.alcada.estruturaUsuario.nomEstruturaUsuario;
      delete this.alcada.estruturaUsuario;
    },
    validarCampos() {
      if (!!this.alcada.vlrLimiteFinal && this.alcada.vlrLimiteFinal > 0) {
        this.$refs.form.validate();
      }
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    save() {
      let salvarOuAtualizar;
      let inclusao = true;
      this.setarTipoFluxo();
      this.setarEstruturaUsuario();
      if (this.alcada.indSemValorFim) {
        this.alcada.vlrLimiteFinal = null;
      }
      this.$emit('FORMULARIO_CADASTRO_ALCADA_SALVAR', this.alcada, this.clearForm);
      if (this.alcada.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.alcadaResources.atualizar(this.alcada);
      } else {
        salvarOuAtualizar = this.alcadaResources.gravar(this.alcada);
      }

      salvarOuAtualizar
        .then(() =>
          this.$toast.create(
            this.$t(
              inclusao
                ? 'message.adicionado_confira_tabela'
                : 'message.atualizado_confira_tabela',
            ),
            'snack',
            3e3,
          ),
        )
        .then(() => {
          this.$emit(
            'FORMULARIO_CADASTRO_ALCADA_SALVAR',
            Object.assign({}, this.alcada),
          );
        })
        .then(() => this.limparFormulario())
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  computed: {
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  mounted() {
    this.buscarTiposFluxo();
    this.buscarEstruturasDeUsuario();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/alcada/AlcadaForm.vue?vue&type=script&lang=js&